const ActionTypes = {
    SET_ALERT: 'SET_ALERT',
    REMOVE_ALERT: 'REMOVE_ALERT',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAIL: 'LOGIN_FAIL',
    USER_LOADED: 'USER_LOADED',
    AUTH_ERROR: 'AUTH_ERROR',
    LOGOUT: 'LOGOUT',
    DEFAULT_DASHBOARD_LOADED: 'DEFAULT_DASHBOARD_LOADED',
    CHANGE_PERIOD: 'CHANGE_PERIOD',
    CHANGE_DIMENSION: 'CHANGE_DIMENSION',
    R_CHANGE_DIMENSION_1: 'R_CHANGE_DIMENSION_1',
    R_CHANGE_DIMENSION_2: 'R_CHANGE_DIMENSION_2',
    R_CHANGE_DIMENSION_3: 'R_CHANGE_DIMENSION_3',
    CHANGE_FILTER: 'CHANGE_FILTER',
    CHANGE_DASHBOARD_FILTERS: 'CHANGE_DASHBOARD_FILTERS',
    CHANGE_PUBLISHER_VIEW: 'CHANGE_PUBLISHER_VIEW',
    LOADING_FILTER_DATA: 'LOADING_FILTER_DATA',
    LOADING_FILTER_DATA_FAIL: 'LOADING_FILTER_DATA_FAIL',
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_FAIL: 'GET_DATA_FAIL',
    GET_DEALS_DATA_SUCCESS: 'GET_DEALS_DATA_SUCCESS',
    GET_DEALS_DATA_FAIL: 'GET_DEALS_DATA_FAIL',
    SWITCH_COMPARISON_MODE: 'SWITCH_COMPARISON_MODE',
    GET_COMPARISON_DATA: 'GET_COMPARISON_DATA',
    GET_COMPARISON_DATA_FAIL: 'GET_COMPARISON_DATA_FAIL',
    GET_TEMP_DATA: 'GET_TEMP_DATA',
    GET_TEMP_DATA_FAIL: 'GET_TEMP_DATA_FAIL',
    GET_TEMP_ITEM: 'GET_TEMP_ITEM',
    GET_TEMP_ITEM_FAIL: 'GET_TEMP_ITEM_FAIL',
    GET_RESOURCES: 'GET_RESOURCES',
    GET_RESOURCES_FAIL: 'GET_RESOURCES_FAIL',
    GET_DATA_AVAILABILITY: 'GET_DATA_AVAILABILITY',
    GET_DATA_AVAILABILITY_FAIL: 'GET_DATA_AVAILABILITY_FAIL',
    ADD_PUBLISHER: 'ADD_PUBLISHER',
    ADD_PUBLISHER_FAIL: 'ADD_PUBLISHER_FAIL',
    DELETE_PUBLISHER: 'DELETE_PUBLISHER',
    DELETE_PUBLISHER_FAIL: 'DELETE_PUBLISHER_FAIL',
    ADD_WEBSITE: 'ADD_WEBSITE',
    ADD_WEBSITE_FAIL: 'ADD_WEBSITE_FAIL',
    DELETE_WEBSITE: 'DELETE_WEBSITE',
    DELETE_WEBSITE_FAIL: 'DELETE_WEBSITE_FAIL',
    ADD_RULE: 'ADD_RULE',
    ADD_RULE_FAIL: 'ADD_RULE_FAIL',
    DELETE_RULE: 'DELETE_RULE',
    DELETE_RULE_FAIL: 'DELETE_RULE_FAIL',
    MAP_ITEM: 'MAP_ITEM',
    MAP_ITEM_FAIL: 'MAP_ITEM_FAIL',
    MAP_ITEMS_BULK: 'MAP_ITEMS_BULK',
    MAP_ITEMS_BULK_FAIL: 'MAP_ITEMS_BULK_FAIL',
    CREATE_REPORT: 'CREATE_REPORT',
    CREATE_REPORT_FAIL: 'CREATE_REPORT_FAIL',
    GET_CRONS: 'GET_CRONS',
    GET_CRONS_FAILS: 'GET_CRONS_FAILS',
    GET_USERS: 'GET_USERS',
    GET_USERS_FAIL: 'GET_USERS_FAIL',
    DELETE_USER: 'DELETE_USER',
    DELETE_USER_FAIL: 'DELETE_USER_FAIL',
    REGISTER_USER: 'REGISTER_USER',
    REGISTER_USER_FAIL: 'REGISTER_USER_FAIL',
    ADD_PLATFORM: 'ADD_PLATFORM',
    ADD_PLATFORM_FAIL: 'ADD_PLATFORM_FAIL',
    DELETE_PLATFORM: 'DELETE_PLATFORM',
    DELETE_PLATFORM_FAIL: 'DELETE_PLATFORM_FAIL',
    EDIT_PLATFORM: 'EDIT_PLATFORM',
    EDIT_PLATFORM_FAIL: 'EDIT_PLATFORM_FAIL',
    GET_TRENDS: 'GET_TRENDS',
    GET_TRENDS_FAIL: 'GET_TRENDS_FAIL',
    SWITCH_SPLIT_MODE: 'SWITCH_SPLIT_MODE',
    SWITCH_IS_DEAL: 'SWITCH_IS_DEAL'
}

export default ActionTypes;